/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { qreq } from "../shared/qrequest";
import FormInput from "./FormInput";
import FormLabel from "./FormLabel";
import Globals from "../shared/Globals";
import { v4 as uuidv4 } from 'uuid';
import Auth from "../shared/Auth";

export default class ProductList extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            order: props.order,
            visit: props.visit,
            list: [],
            loaded: false,
            edit: props.edit,
            products: [],
            sizes: []
        }

        this.load = this.load.bind(this);
        this.validate = this.validate.bind(this);
        this.save = this.save.bind(this);
        this.edit = this.edit.bind(this);
        this.remove = this.remove.bind(this);
        this.canAddMore = this.canAddMore.bind(this);
    }

    componentDidMount() {

        qreq.post('/api/product/list', {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.name);
                    if (!product)
                        products.push({ id: i.name, name: i.name });
                    var size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.id, name: i.productSize, productName: i.name, productID: i.id });
                    }
                });
                this.sizes = sizes;
                this.setState({ products: products });
                this.load();
            }
        });

    }

    filterSizes(obj, sel) {
        if (!sel || !this.sizes) {
            obj.sizes = [];
            return;
        }
        var sizes = [];
        this.sizes.forEach(i => {
            if (i.productName === sel)
                sizes.push(i);
        });
        obj.sizes = sizes;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.order !== this.props.order) {
            this.setState({ order: this.props.order });
            this.load();
        }
        if (prevProps.visit !== this.props.visit) {
            this.setState({ visit: this.props.visit });
            this.load();
        }
        if (prevProps.edit !== this.props.edit)
            this.setState({ edit: this.props.edit });

        if (this.state.list) {
            var updated = false;
            for (var n = 0; n < this.state.list.length; n++) {
                if (!this.state.list[n].quantity || this.state.list[n].quantity < 1) {
                    this.state.list[n].quantity = 1;
                    updated = true;
                }
                if (this.state.list[n].inputExpirationDate)
                    this.state.list[n].inputExpirationDate = Globals.toMDYDateString(new Date(this.state.list[n].inputExpirationDate));
            }
            if (updated)
                this.setState({ list: this.state.list });
        }
    }

    load() {
        var list = null;
        if (this.state.visit && Array.isArray(this.state.visit.products)) {
            list = this.state.visit.products;
        }
        else if (this.state.order && Array.isArray(this.state.order.products)) {
            list = this.state.order.products;
        }

        list.forEach(i => {
            i.entry = Globals.deepClone(i, 'entry');
            i.productName = i.name;
            i.productSize = i.id;
            i.lotNumber = i.orderProduct.lotNumber;
            i.expirationDate = i.orderProduct.expirationDate;
            this.filterSizes(i, i.productName);
        });

        this.setState({ list: list });
    }

    validate(obj) {
        if (obj.quantity < 1) {
            obj.quantity = 1;
            this.setState({ list: this.state.list });
        }
    }

    save(obj) {
        if (obj.productName) {
            var req = { ...obj };
            req.entry = null;
            if (this.state.visit) {
                req.visitID = this.state.visit.id;
                req.orderID = this.state.visit.orderID;
            }
            if (this.state.order)
                req.orderID = this.state.order.id;

            var size = this.sizes.find(i => i.id === Number(req.productSize));

            if (!size)
                return;

            req.productID = req.productSize;
            req.productSize = size.name;

            var idx = this.state.list.indexOf(obj);

            req.id = req.orderProduct?.id;

            if (this.props.visit) {
                qreq.post('/api/product/visit/save', req, j => {
                    if (j.errorCode === 0) {
                        j.item.productName = j.item.name;
                        j.item.productSize = j.item.id;
                        j.item.lotNumber = j.item.orderProduct.lotNumber;
                        j.item.expirationDate = j.item.orderProduct.expirationDate;
                        this.filterSizes(j.item, req.productName);
                        j.item.edit = false;

                        this.state.list[idx] = j.item;
                        this.setState({ list: this.state.list });
                    }
                });
            }
            else if (this.props.order) {
                qreq.post('/api/product/order/save', req, j => {
                    if (j.errorCode === 0) {
                        j.item.productName = j.item.name;
                        j.item.productSize = j.item.id;
                        j.item.lotNumber = j.item.orderProduct.lotNumber;
                        j.item.expirationDate = j.item.orderProduct.expirationDate;
                        this.filterSizes(j.item, req.productName);
                        j.item.edit = false;

                        this.state.list[idx] = j.item;
                        this.setState({ list: this.state.list });
                    }
                });
            }
        }
    }

    edit(obj) {
        obj.edit = true;
        this.setState({ list: this.state.list });
    }

    remove(obj) {
        if (obj.id && obj.orderProduct.id) {
            var req = { ...obj };
            req.entry = null;
            req.productID = req.id;
            if (this.state.visit) {
                req.visitID = this.state.visit.id;
                req.orderID = this.state.visit.orderID;
            }
            if (this.state.order)
                req.orderID = this.state.order.id;
            req.productSize = String(req.productSize);
            qreq.post('/api/product/visit/remove', req, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
            });
        }
        this.state.list.splice(this.state.list.indexOf(obj), 1);
        this.setState({ list: this.state.list });
    }

    canAddMore() {
        for (var n = 0; n < this.state.list.length; n++) {
            if (!this.state.list[n].id)
                return false;
        }
        return true;
    }

    render() {
        return <Card title="Products">
            <table className="table">
                {this.state.list.map(obj => <tbody key={obj.key ? obj.key : obj.orderProduct.id}>
                    {obj.edit ? <>
                        <tr>
                            <td><L>Product Name</L></td>
                            <td>Size (cm)</td>
                            <td><L>Quantity</L></td>
                            <td><L>Lot #</L></td>
                            <td><L>Exp. Date</L></td>
                            {!this.props.disabled && <td></td>}
                        </tr>
                        <tr>
                            <td>
                                <FormInput model={obj} name="productName" label="Product" type="select" options={this.state.products} labelAsPlaceholder required onChange={(sel) => {
                                    this.filterSizes(obj, sel);
                                    this.setState({ list: this.state.list });
                                }} />
                            </td>
                            <td>
                                <FormInput model={obj} name="productSize" label="Size" type="select" options={obj.sizes} labelAsPlaceholder disabled={!obj.productName} required />
                            </td>
                            <td><FormInput model={obj} name="quantity" label="Qty" type="number" labelAsPlaceholder required onChange={() => this.validate(obj)} disabled={!obj.productName} /></td>
                            <td><FormInput model={obj} name="lotNumber" label="Lot Number" type="text" labelAsPlaceholder required onChange={() => this.validate(obj)} disabled={!obj.productName} /></td>
                            <td><FormInput model={obj} name="inputExpirationDate" label="Exp. Date" type="date" labelAsPlaceholder required onChange={() => this.validate(obj)} disabled={!obj.productName} /></td>
                            {!this.props.disabled && <td style={{ minWidth: '120px' }}>
                                <button type="button" className="btn btn-success" disabled={!obj.productName} onClick={() => this.save(obj)}><FontAwesomeIcon icon={fa.faSave} /></button>
                                <button type="button" className="btn btn-danger" onClick={() => this.remove(obj)}><FontAwesomeIcon icon={fa.faTrash} /></button>
                            </td>}
                        </tr>
                    </> : <>
                        <tr>
                            <td><L>Product Name</L></td>
                            <td><L>Size</L></td>
                            <td><L>Qty</L></td>
                            <td><L>Lot #</L></td>
                            <td><L>Exp. Date</L></td>
                            {this.props.showPrice && <td><L>Price</L></td>}
                            {!this.props.disabled && <td></td>}
                        </tr>
                        <tr>
                            <td><FormLabel model={obj.productName} label="" /></td>
                            <td><FormLabel model={obj.orderProduct.size} label="" /></td>
                            <td><FormLabel model={obj.orderProduct.quantity} label="" /></td>
                            <td><FormLabel model={obj.orderProduct.lotNumber} label="" /></td>
                            <td><FormLabel model={obj.orderProduct.expirationDate} label="" /></td>
                            {this.props.showPrice && <td><FormLabel model={Globals.getCurrencyFormatter().format(obj.price * obj.quantity * obj.orderProduct.productSizeLength * obj.orderProduct.productSizeWidth)} label="" /></td>}
                            {!this.props.disabled && <td><button type="button" className="btn btn-secondary" onClick={() => this.edit(obj)}><FontAwesomeIcon icon={fa.faPencil} /></button></td>}
                        </tr></>}</tbody>)}
            </table>
            {this.canAddMore() && !Auth.hasRole('readonly') && !this.props.disabled ?
                <div className="btn-group mt-2">
                    <button type="button" className="btn btn-primary" onClick={() => { this.state.list.push({ key: uuidv4(), edit: true, sizes: [], orderProduct: { productSizeWidth: 4, productSizeLength: 4, expirationDate: Globals.toMDYDateString(new Date()) }, quantity: 1 }); this.setState({ list: this.state.list }); }}><FontAwesomeIcon icon={fa.faPlus} /><L>Add Product</L></button>
                </div> : ''}
        </Card>;
    }
}